import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Card, message } from "antd";
import AdminClientHeader from "modules/admin/clients/components/header/AdminClientHeader";
import bwipjs from "bwip-js";
import "./Pdf417GeneratorPage.scss";

const Pdf417GeneratorPage = () => {
  const [form] = Form.useForm();
  const [barcodeData, setBarcodeData] = useState("");
  const canvasRef = useRef(null);

  const breadCrumbs = [{ text: "PDF417 GENERATOR" }];

  const generateBarcodeData = (values) => {
    const { name, phone, address1, address2, city, state, zip } = values;

    console.log("Form values:", values);
    console.log("Address Line 2:", address2);

    // Base template with placeholders
    // The format includes special control characters:
    // - 0x1D (group separator) represented as the delimiter between sections
    // - 0x1C (file separator) at the end
    const template = `[)>010278705840060000000000000201FDE5100873210841/150.5LB${address1}${city}${state} ${zip}10ZED00511Z${name}12Z${phone}31Z100191413376000787050000000000000032Z14Z${
      address2 || ""
    }15Z10001679820Z KGR456789226Z3ad2`;

    console.log("Generated template:", template);

    return template;
  };

  const generateBarcode = (data) => {
    if (!canvasRef.current) {
      console.log("Canvas ref not available");
      return;
    }

    console.log("Generating barcode with data:", data);

    try {
      bwipjs.toCanvas(canvasRef.current, {
        bcid: "pdf417",
        text: data,
        scale: 3,
        height: 10,
        includetext: false,
        padding: 10
      });
      console.log("Barcode generated successfully");
    } catch (error) {
      console.error("Barcode generation error:", error);
      message.error("Failed to generate barcode visualization: " + error.message);
    }
  };

  const handleGenerate = async (values) => {
    try {
      const data = generateBarcodeData(values);
      setBarcodeData(data);
      message.success("Barcode data generated successfully!");
    } catch (error) {
      message.error("Failed to generate barcode data");
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("useEffect triggered, barcodeData:", barcodeData);
    if (barcodeData && canvasRef.current) {
      console.log("Calling generateBarcode");
      generateBarcode(barcodeData);
    } else {
      console.log("Conditions not met:", { barcodeData, hasCanvas: !!canvasRef.current });
    }
  }, [barcodeData]);

  return (
    <div className="pdf417-generator-page">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />

      <div className="content-wrapper">
        <Card title="Contact Information">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleGenerate}
            initialValues={{
              name: "Recipient Company Name",
              phone: "9012637906",
              address1: "NW 34th Street",
              address2: "Suite 100",
              city: "Austin",
              state: "TX",
              zip: "06"
            }}
          >
            <Form.Item
              label="Contact Name"
              name="name"
              rules={[{ required: true, message: "Please enter contact name" }]}
            >
              <Input placeholder="Enter contact name" />
            </Form.Item>

            <Form.Item
              label="Phone"
              name="phone"
              rules={[{ required: true, message: "Please enter phone number" }]}
            >
              <Input placeholder="Enter phone number" />
            </Form.Item>

            <Form.Item
              label="Address Line 1"
              name="address1"
              rules={[{ required: true, message: "Please enter address line 1" }]}
            >
              <Input placeholder="Enter address line 1" />
            </Form.Item>

            <Form.Item label="Address Line 2" name="address2">
              <Input placeholder="Enter address line 2 (optional)" />
            </Form.Item>

            <Form.Item
              label="City"
              name="city"
              rules={[{ required: true, message: "Please enter city" }]}
            >
              <Input placeholder="Enter city" />
            </Form.Item>

            <Form.Item
              label="State"
              name="state"
              rules={[{ required: true, message: "Please enter state" }]}
            >
              <Input placeholder="Enter state" maxLength={2} />
            </Form.Item>

            <Form.Item
              label="Zip Code"
              name="zip"
              rules={[{ required: true, message: "Please enter zip code" }]}
            >
              <Input placeholder="Enter zip code" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" size="large">
                Generate PDF417 Barcode
              </Button>
            </Form.Item>
          </Form>
        </Card>

        {barcodeData && (
          <Card title="Generated Barcode Data" className="barcode-result">
            <div className="barcode-data">
              <p>
                <strong>Encoded Data:</strong>
              </p>
              <pre>{barcodeData}</pre>
            </div>

            <div className="barcode-image">
              <p>
                <strong>PDF417 Barcode:</strong>
              </p>
              <div className="barcode-canvas-wrapper">
                <canvas ref={canvasRef}></canvas>
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

export default Pdf417GeneratorPage;
